// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__203i9","title":"AfterBackImages_title__1Nzkf","images":"AfterBackImages_images__3uReU"};